<template>
  <nav>
    <v-card height="715" flat color="rgba(0,0,0,0)" style="border-radius: 10px;" class="pb-">
      <v-card class="card1 ml-3 mr-3 mt-2">
        <v-carousel height="270" hide-delimiters :cycle="false">
          <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item"></v-carousel-item>
        </v-carousel>
      </v-card>
      <v-card class="card2 pl-3 pr-3 pb-2">
        <v-card class="card3" flat>
          <center>
            <div style="padding-top: 255px; font-size: 18px;">
              
              <v-card class="mt-3 mb-4 ml-1 mr-1" flat style="border-radius: 50px;" height="70px" color="grey lighten-3">
                
                  <v-container fill-height style="padding: 0px; margin: 0px;">
                  <v-avatar size="90" class="">
                    <v-img
                      :src="posted_by.avatar"
                    />
                  </v-avatar>
                  <span class="ml-3 font-weight-light" style="font-size: 22px;">
                    {{ posted_by.name }}
                  </span>
                  </v-container>
                
              </v-card>

              <span class="headline green--text stopflow">{{item_name}}</span>
              <v-divider class="mb-2" />
              <span>Price Marked: </span>
              <span class="green--text font-weight-bold">&#8377;{{marked_price}}</span>
							<br/>
							<span>Category: </span>
							<span class="green--text font-weight-bold">{{category}}</span>
              <br/>
							<span>My Bid: </span>
							<span class="green--text font-weight-bold">&#8377;{{bid}}</span>
            </div>
          </center>

          
        </v-card>
      </v-card>
    </v-card>
  </nav>
</template>
<script>
import firebase from "firebase";

export default {
  props: {
    item_name: String,
    category: String,
    marked_price: Number,
    photos: Array,
    posted_by: Object,
    postId: String,
    bid: Number
  },

  data() {
    return {
    };
  },


};
</script>

<style scoped>
.card1 {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  top: 0px;
}
.card2 {
  border-radius: 10px;
  position: relative;
  bottom: 240px;
  z-index: 0;
}
.card3 {
  border-radius: 0px 0px 10px 10px;
  z-index: 0;
}
.scroll {
  overflow-y: auto;
}
.stopflow {
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
</style>